<template>
  <div>

    <!-- pc -->
    <div class="viewPC separateTable mb10">
      <div class="mdTblColumn">
        <table class="mdTable01">
          <colgroup>
            <col width="25%">
            <col width="25%">
            <col width="25%">
          </colgroup>
          <tr class="separateTableHeader">
            <th
              v-for="item, index in items"
              :key="index"
              class="pdSet02"
            ><span v-html="item.html"></span><p class="mdTxtUpdate01" v-html="$store.getters['status/displayAt'](item.status)"></p></th>
          </tr>

          <tr class="separateTableBody">
            <td
              v-for="item, index in items"
              :key="index"
            >
              <div class="buttonArea">
                <p
                  v-for="link, index in item.links"
                  :key="'link-' + index"
                  class="mdButton02"
                  :class="{'mt15': index > 0 }"
                >
                  <a v-linkset="link.linkset" target="_blank" :href="link.href">
                    <span v-if="link.type === 'excel'" class="icoExcel">Excel</span>
                    <span v-else-if="link.type === 'pdf'" class="icoPdf">PDF</span>
                    <span v-else>{{link.html}}</span>
                  </a>
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- sp -->
    <div class="viewSP mdTableSpColumn2 mb10">
      <div
        v-for="row, rowIndex in separatedItemRows"
        :key="rowIndex"
        class="mdTblColumn"
        :class="rowIndex % 2 === 0 ? 'separateTableLeft' : 'mdTblRight separateTableRight'"
      >
        <table class="mdTable01 mdSpMb">
          <colgroup>
            <col width="50%">
            <col width="50%">
          </colgroup>
          <tbody>
            <tr class="separateTableHeader">
              <th
                class="pdSet02"
                v-for="item, index in row"
                :key="rowIndex + '-' + index"
              >
                <span v-html="item.html"></span>
                <p class="mdTxtUpdate01" v-html="$store.getters['status/displayAt'](item.status)"></p>
              </th>
            </tr>
            <tr class="separateTableBody">
              <td
                v-for="item, index in row"
                :key="rowIndex + '-' + index"
              >
                <p
                  v-for="link, index in item.links"
                  :key="'link-' + index"
                  class="mdButton02"
                  :class="{'mt15': index > 0 }"
                >
                  <a v-linkset="link.linkset" target="_blank" :href="link.href">
                    <span v-if="link.type === 'excel'" class="icoExcel">Excel</span>
                    <span v-else-if="link.type === 'pdf'" class="icoPdf">PDF</span>
                    <span v-else>{{link.html}}</span>
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>



<script>

export default {
  name: 'dn-sokuhou-seikaihaiten-app',

  computed: {
    separatedItemRows() {
      const rows = [];
      let rowIndex = -1;
      this.items.forEach((item, index) => {
        const myIndex = index % 2;
        if (myIndex === 0) {
          rowIndex++;
          rows[rowIndex] = [];
        }
        rows[rowIndex].push(item);
      });
      return rows;
    },
  },
}
</script>

<style scoped>
.mdTable01{
  border: none;
}
</style>


// WEBPACK FOOTER //
// App.vue?c719a10a